export const LOAN_FILES_TABLE_LAYOUT_TYPES = {
  LIST: "list",
  CATEGORY: "category",
  TYPE: "type",
  CATEGORY_AND_TYPE: "category_and_type",
  STATUS: "status",
  CHECKLIST: "checklist",
  PARSED_AND_EXTRACTED: "parsed_and_extracted",
  HIDDEN: "hidden",
};
